const Divider = ({ className }) => (
  <div className={`h-3/4 my-auto border-l mx-2 border-black ${className}`} />
);

export default Divider;
